<div class="menu">
	<div class="icon" (click)="toggleMenu(true)">{{ expand ? 'close' : 'menu' }}</div>
</div>
<div class="items" [ngClass]="{ expand: expand }">
	<!-- Expand/Collapse Toggle -->
	<div class="nav-toggle">
		<div class="icon" (click)="toggleMenu()">{{ expand ? 'keyboard_double_arrow_left' : 'keyboard_double_arrow_right' }}</div>
	</div>

	<!-- Home Icon -->
	<div class="item" [ngClass]="{ expand: expand, active: isHomeActive }" (click)="navigateToHome()">
		<div class="icon icon-image" title="Home Dashboard" [ngClass]="{ active: isHomeActive }">
			<img src="assets/home1.png" alt="Home Dashboard" class="nav-icon-img home-icon-img" width="32" height="32">
		</div>
		<div class="title" [ngClass]="{ expand: expand, active: isHomeActive }">Home</div>
	</div>

	   <!-- Upload Icon -->
	   <!-- <div class="item" *ngIf="selectedBU === 'RBU'" 
			[ngClass]="{ 
				expand: expand, 
				disabled: !isBuSelected, 
				active: isBuSelected && isUploadActive
			}" 
			(click)="openUploadModal()"
			(mousemove)="onNavItemMouseMove($event, $event.currentTarget)">
		   <div class="icon icon-image" title="Upload Excel" 
				[ngClass]="{ active: isBuSelected && isUploadActive }">
			   <img src="assets/upload.png" alt="Upload Excel" class="nav-icon-img upload-icon-img" width="32" height="32">
		   </div>
		   <div class="title" 
				[ngClass]="{ expand: expand, active: isBuSelected && isUploadActive }">
			   Upload Excel
		   </div>
	   </div> -->

	   <ng-container *ngFor="let item of navItems">
		   <div class="item"
				[ngClass]="{ 
					active: isBuSelected && !isUploadActive && (
						(item.title === 'Wells' && (router.url.startsWith('/wells') || router.url.startsWith('wells'))) ||
						(activeItem && item.title === activeItem.title && item.title !== 'Wells')
					), 
					expand: expand, 
					disabled: !isBuSelected
				}"
				(click)="navigateTo(item)">
			   <div class="icon" [title]="item.title"
					[ngClass]="{ 
						active: isBuSelected && !isUploadActive && (
							(item.title === 'Wells' && (router.url.startsWith('/wells') || router.url.startsWith('wells'))) ||
							(activeItem && item.title === activeItem.title && item.title !== 'Wells')
						),
						'icon-image': item.imageIcon
					}">
					<img *ngIf="item.imageIcon" [src]="item.imageIcon" [alt]="item.title" [ngClass]="{ 'nav-icon-img': true, 'oil-rig-icon-img': item.imageIcon && item.imageIcon.includes('oil-rig') }" width="32" height="32">
					<span *ngIf="!item.imageIcon">{{ item.icon }}</span>
			   </div>
			   <div class="title" [ngClass]="{ 
					active: isBuSelected && !isUploadActive && (
						(item.title === 'Wells' && (router.url.startsWith('/wells') || router.url.startsWith('wells'))) ||
						(activeItem && item.title === activeItem.title && item.title !== 'Wells')
					), 
					expand: expand 
				}">{{ item.title }}</div>

			   <ng-container *ngFor="let subItem of navSubItems">
				   <div class="sub" [ngClass]="{ expand: expand }" *ngIf="subItem.parent === item.title">
					   <div class="arrow" [ngClass]="{ active: isBuSelected && activeItem && subItem.title === activeItem.title }">►</div>
					   <div class="line"></div>
					   <div class="icon" [ngClass]="{ active: isBuSelected && activeItem && subItem.title === activeItem.title }" [title]="subItem.title" (click)="navigateTo(subItem)">{{ subItem.icon }}</div>
					   <div class="title" [ngClass]="{ active: isBuSelected && activeItem && subItem.title === activeItem.title }" (click)="navigateTo(subItem)">{{ subItem.title }}</div>
				   </div>
			   </ng-container>
		   </div>
	   </ng-container>

	<div class="toggle" [ngClass]="{ expand: expand }">
		<div [title]="appTitle" class="icon" (click)="toggleFullscreen()">{{ appIcon }}</div>
	</div>
</div>

<footer [ngClass]="{ expand: expand }"></footer>
